/*
 * Copyright © 2020-2025 Ocean Galaxy Inc. All Rights Reserved.
 * @Description: 账号封禁弹窗组件
 * @LastEditors: yingongjing
 * @LastEditTime: 2025-12-12 15:03:06
 */
import React from 'react'
import { Modal, Button } from 'antd'
import ContactUS from '../../components/ContactUS'
import './BannedAccountModal.scss'
import { ExclamationCircleOutlined } from '@ant-design/icons'

interface BannedAccountModalProps {
  open: boolean
  unbanTime?: string
  onClose: () => void
  onContactService?: () => void
  onConfirm?: () => void
}

const BannedAccountModal: React.FC<BannedAccountModalProps> = ({
  open,
  unbanTime,
  onClose,
  onContactService,
  onConfirm
}) => {
  return (
    <Modal
      open={open}
      footer={null}
      closable={false}
      mask={{ closable: false }}
      width={480}
      className="banned-account-modal"
    >
      <div className="banned-modal-content">
        <div className="banned-icon-wrapper">
          <ExclamationCircleOutlined style={{ fontSize: '24px' }} />
        </div>
        <div className="banned-content">
          <div className="banned-title">你的账号已被封禁, 暂不支持验真</div>
          {unbanTime && (
            <div className="banned-time">账号将于{unbanTime}解封</div>
          )}
          <div className="banned-actions">
            <ContactUS
              fromPage="webBanVerification"
              track={() => {
                // 埋点：联系客服
                onContactService && onContactService()
                // 关闭弹窗
                onClose()
              }}
            >
              <Button className="banned-contact-btn">联系客服</Button>
            </ContactUS>
            <Button
              type="primary"
              onClick={() => {
                // 埋点：我知道了
                onConfirm && onConfirm()
                // 关闭弹窗
                onClose()
              }}
              className="banned-confirm-btn"
            >
              我知道了
            </Button>
          </div>
        </div>
      </div>
    </Modal>
  )
}

export default BannedAccountModal
